import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDocumentSetList,
  getListCustomerList,
} from "../../services/MoloniServices";
import {
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import { getCommonSearchList } from "../../services/settingsServices";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  createInternalInvoice,
  createmarketPlaceInvoice,
  deleteInvoiceFileInternalSales,
  getCheckMCustomer,
  getEcommerceSalesDetailsList,
  internalSalesFileUpdate,
} from "../../services/SalesServices";
import { getInternalSalesDetails } from "../../services/PartTypeService";
import ConfigDB from "../../config";

const AcceptedInternal = () => {
  const navigate = useNavigate();

  const state = useLocation();
  const statusChange = state?.state?.statusChange;
  const selectedParts = state?.state?.selectedParts || [];

  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const [selectedRadioAccepted, setSelectedRadioAccepted] = useState("1");
  const [selectedInternalFiles, setSelectedInternalFiles] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageId, setImageId] = useState("");
  const [customerModel, setCustomerModel] = useState(false);
  const [customerAllList, setCustomerAllList] = useState([]);
  const [syncFormData, setSyncFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    expiration_date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    our_reference: "",
    your_reference: "",
    notes: "",
    total_value_packaging: "",
    total_value_other_parcel: "",
    total_value_shipping: "",
    exemption_vat_products: "",
    exemption_vat_shipping: "",
    exemption_vat_packaging: "",
    selected_ids: [],
    exemption_reason: "",
  });
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);
  let errorsObj = {
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
    your_reference: "",
    our_reference: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [loading, setLoading] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const [statusChangeDetails, setStatusChangeDetails] = useState("");
  // At the top of your component
  // const [updatedStatusChange, setUpdatedStatusChange] = useState({
  //   ...statusChangeDetails,
  //   part_list: [...(statusChangeDetails.part_list  || statusChangeDetails.proudct_list || []), ...selectedParts],
  // });
  const [updatedStatusChange, setUpdatedStatusChange] = useState("");
  const [partdeletedList, setPartdeletedList] = useState([]);
  const [checkMCustomerList, setCheckMCustomerList] = useState("");
  const [loadingCustomerList, setLoadingCustomerList] = useState(false);

  const handleOpen = () => {
    window.open(imagePreview, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (statusChangeDetails) {
      setUpdatedStatusChange({
        ...statusChangeDetails,
        part_list: [
          ...(statusChangeDetails.part_list ||
            statusChangeDetails.proudct_list ||
            []),
          ...selectedParts,
        ],
      });
    }
  }, [statusChangeDetails]);

  // useEffect(() => {
  //   if (
  //     !hasCalled.current &&
  //     selectedRadioAccepted === "2" &&
  //     state?.pathname === "/accept-invoice-sales" &&
  //     updatedStatusChange?.id
  //   ) {
  //     hasCalled.current = true;
  //     setLoadingCustomerList(true);

  //     let data = {
  //       id: updatedStatusChange.id,
  //       sales_type: 1,
  //     };

  //     getCheckMCustomer(data)
  //       .then((response) => {
  //         setCheckMCustomerList(response.data.data);
  //         setLoadingCustomerList(false);
  //       })
  //       .catch((err) => {
  //         setLoadingCustomerList(false);
  //         toast.error(Utils.getErrorMessage(err));
  //       });
  //   }
  // }, [selectedRadioAccepted, updatedStatusChange?.id, state?.pathname]);

  useEffect(() => {
    if (checkMCustomerList?.moloni_id) {
      setSyncFormData((prev) => ({
        ...prev,
        customer_id: checkMCustomerList.moloni_id,
      }));
    }
  }, [checkMCustomerList]);

  useEffect(() => {
    if (updatedStatusChange && state?.pathname === "/accept-invoice-sales") {
      setSyncFormData((prev) => ({
        ...prev,
        total_value_packaging: updatedStatusChange?.total_value_packaging,
        total_value_other_parcel: updatedStatusChange?.total_value_other_parcel,
        total_value_shipping: updatedStatusChange?.total_value_shipping,
      }));
    }
  }, [updatedStatusChange]);

  useEffect(() => {
    if (state?.state?.selectedRadioAccepted === 2) {
      setSelectedRadioAccepted("2");
    }
  }, [state]);

  const handleFileChangeImageInternal = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedInternalFiles([file]);

    // Image preview
    if (file.type.startsWith("image/")) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    } else {
      setImagePreview(null);
    }
  };

  const removeFile = () => {
    setSelectedInternalFiles([]);

    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (imageId) {
      setImageLoader(true);
      const data = { id: imageId, sales_type: 2 };

      deleteInvoiceFileInternalSales(data)
        .then((response) => {
          toast.success(response.data.message);
          setImageLoader(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setImageLoader(false);
        });
    }
  };

  const handleCustomerModelClose = () => {
    setCustomerModel(false);
  };

  const handleCustomerModelOpen = () => {
    if (state?.pathname === "/accept-invoice-sales") {
      setCustomerModel(true);

      let data = {
        id: updatedStatusChange?.id,
      };

      getEcommerceSalesDetailsList(data)
        .then((response) => {
          setCustomerAllList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      setCustomerModel(true);
      let data = {
        uuid: updatedStatusChange?.uuid,
      };

      getInternalSalesDetails(data)
        .then((response) => {
          setCustomerAllList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  useEffect(() => {
    if (updatedStatusChange?.image_list?.length > 0) {
      const file = updatedStatusChange.image_list[0];
      setImagePreview(file?.image_url);
      setImageId(file?.id);
    }
  }, [updatedStatusChange]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_deleted_condition",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartdeletedList(list);
      })
      .catch((err) => {});
  }, []);

  const handleRadioInternalSaleChange = (event) => {
    const value = event.target.value;
    setSelectedRadioAccepted(value);

    if (
      state?.pathname === "/accept-invoice-sales" &&
      updatedStatusChange?.id &&
      value === "2" &&
      updatedStatusChange?.is_moloni_invoice !== 1
    ) {
      setLoadingCustomerList(true);

      let data = {
        id: updatedStatusChange.id,
        sales_type: 1,
      };

      getCheckMCustomer(data)
        .then((response) => {
          setCheckMCustomerList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingCustomerList(false);
        });
    }
  };

  useEffect(() => {
    if (state?.pathname === "/accept-invoice-sales") {
      let data = {
        id: statusChange?.id,
      };

      getEcommerceSalesDetailsList(data)
        .then((response) => {
          const result = response?.data?.data || {};
          setStatusChangeDetails(result);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      let data = {
        uuid: statusChange?.uuid,
      };

      getInternalSalesDetails(data)
        .then((response) => {
          setStatusChangeDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [state]);

  const handleAddAccpetedStatusInternalSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (state?.pathname === "/accept-invoice-sales") {
      if (selectedRadioAccepted === "1") {
        const formData = new FormData();
        formData.append("internal_sales_id", updatedStatusChange.id);
        formData.append("sales_status", 3);
        selectedInternalFiles.forEach((file) => {
          formData.append("order_images", file);
        });
        formData.append("sales_type", 2);

        internalSalesFileUpdate(formData)
          .then((response) => {
            toast.success(response.data.message);
            navigate("/sales");
            setLoading(false);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
          });
      }

      if (selectedRadioAccepted === "2") {
        setLoading(true);

        let errorObj = {};
        let hasError = false;
        if (Number(updatedStatusChange?.is_moloni_invoice) === 0) {
          if (!syncFormData?.date) {
            errorObj.date = "Date is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.document_set_id) {
            errorObj.document_set_id = "Document Set is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.customer_id) {
            errorObj.customer_id = "Customer is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.expiration_date) {
            errorObj.expiration_date = "Expiration Date is required.";
            hasError = true;
          } else if (syncFormData?.date) {
            const start = new Date(syncFormData.date);
            const end = new Date(syncFormData.expiration_date);

            if (end < start) {
              errorObj.expiration_date = "Expiration Date must be after Date.";
              hasError = true;
              setLoading(false);
            }
          }

          if (!syncFormData?.your_reference) {
            errorObj.your_reference = "Your Reference is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.our_reference) {
            errorObj.our_reference = "Our Reference is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.notes) {
            errorObj.notes = "Notes is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_packaging) {
            errorObj.total_value_packaging =
              "Total value packaging is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_other_parcel) {
            errorObj.total_value_other_parcel =
              "Total value other value is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_shipping) {
            errorObj.total_value_shipping = "Total value shipping is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_products) {
            errorObj.exemption_vat_products =
              "Exemption vat products is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_shipping) {
            errorObj.exemption_vat_shipping =
              "Exemption vat shipping is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_packaging) {
            errorObj.exemption_vat_packaging =
              "Exemption vat packaging is required.";
            hasError = true;
            setLoading(false);
          }
          if (!syncFormData?.exemption_reason) {
            errorObj.exemption_reason = "Exemption reason is required.";
            hasError = true;
            setLoading(false);
          }
        }

        setErrors(errorObj);
        Utils.focusError();

        if (hasError) {
          setLoading(false);
          return;
        }

        const invoicePartList = updatedStatusChange.part_list.map((part) => ({
          id: part.id || 0, // if id exists, use it, else 0
          part_id: part.part_id || part.product_id,
          sales_price:
            part.internal_sales_price || part.price_without_vat || "0",
          delete_status_id: part.deleted_part_id || 0, // set 2 if deleted, 0 if not
          part_qty_id: part.part_qty_id || 0,
          location_id: part.location_id || 0,
          notes: part.notes || "",
        }));

        let payload = {
          id: statusChange?.id,
          date: syncFormData?.date,
          expiration_date: syncFormData?.expiration_date,
          document_set_id: syncFormData?.document_set_id,
          customer_id: syncFormData?.customer_id,
          our_reference: syncFormData?.our_reference,
          your_reference: syncFormData?.your_reference,
          notes: syncFormData?.notes,
          total_value_packaging: syncFormData?.total_value_packaging,
          total_value_other_parcel: syncFormData?.total_value_other_parcel,
          total_value_shipping: syncFormData?.total_value_shipping,
          exemption_vat_products: syncFormData?.exemption_vat_products,
          exemption_vat_shipping: syncFormData?.exemption_vat_shipping,
          exemption_vat_packaging: syncFormData?.exemption_vat_packaging,
          sales_type: 2,
          button_type: 2,
          invoice_part_list: invoicePartList,
          is_moloni_invoice: updatedStatusChange?.is_moloni_invoice,
          exemption_reason: syncFormData?.exemption_reason,
        };

        createmarketPlaceInvoice(payload)
          .then((response) => {
            toast.success(response.data.message);
            navigate("/sales");
            setSyncFormData({
              price_value: "",
              selected_ids: [],
            });
            setLoading(false);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      if (selectedRadioAccepted === "1") {
        const formData = new FormData();
        formData.append("internal_sales_id", updatedStatusChange.id);
        formData.append("sales_status", 3);
        selectedInternalFiles.forEach((file) => {
          formData.append("order_images", file);
        });
        formData.append("sales_type", 2);

        internalSalesFileUpdate(formData)
          .then((response) => {
            navigate("/internal-sales");
            toast.success(response.data.message);
            setLoading(false);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
          });
      }

      if (selectedRadioAccepted === "2") {
        setLoading(true);

        let errorObj = {};
        let hasError = false;
        if (Number(updatedStatusChange?.is_moloni_invoice) === 0) {
          if (!syncFormData?.date) {
            errorObj.date = "Date is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.document_set_id) {
            errorObj.document_set_id = "Document Set is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.customer_id) {
            errorObj.customer_id = "Customer is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.expiration_date) {
            errorObj.expiration_date = "Expiration Date is required.";
            hasError = true;
          } else if (syncFormData?.date) {
            const start = new Date(syncFormData.date);
            const end = new Date(syncFormData.expiration_date);

            if (end < start) {
              errorObj.expiration_date = "Expiration Date must be after Date.";
              hasError = true;
              setLoading(false);
            }
          }

          if (!syncFormData?.your_reference) {
            errorObj.your_reference = "Your Reference is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.our_reference) {
            errorObj.our_reference = "Our Reference is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.notes) {
            errorObj.notes = "Notes is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_packaging) {
            errorObj.total_value_packaging =
              "Total value packaging is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_other_parcel) {
            errorObj.total_value_other_parcel =
              "Total value other value is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.total_value_shipping) {
            errorObj.total_value_shipping = "Total value shipping is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_products) {
            errorObj.exemption_vat_products =
              "Exemption vat products is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_shipping) {
            errorObj.exemption_vat_shipping =
              "Exemption vat shipping is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_vat_packaging) {
            errorObj.exemption_vat_packaging =
              "Exemption vat packaging is required.";
            hasError = true;
            setLoading(false);
          }

          if (!syncFormData?.exemption_reason) {
            errorObj.exemption_reason = "Exemption reason is required.";
            hasError = true;
            setLoading(false);
          }
        }

        setErrors(errorObj);
        Utils.focusError();

        if (hasError) {
          setLoading(false);
          return;
        }

        const invoicePartList = updatedStatusChange.part_list.map((part) => ({
          id: part.id || 0, // if id exists, use it, else 0
          part_id: part.part_id || part.parts_id || part.product_id,
          sales_price:
            part.internal_sales_price || part.price_without_vat || "0",
          delete_status_id: part.deleted_part_id || 0, // set 2 if deleted, 0 if not
          part_qty_id: part.part_qty_id || part.part_qty_label_id || 0,
          location_id: part.location_id || 0,
          notes: part.notes || "",
        }));

        let payload = {
          id: updatedStatusChange?.id,
          date: syncFormData?.date,
          expiration_date: syncFormData?.expiration_date,
          document_set_id: syncFormData?.document_set_id,
          customer_id: syncFormData?.customer_id,
          our_reference: syncFormData?.our_reference,
          your_reference: syncFormData?.your_reference,
          notes: syncFormData?.notes,
          total_value_packaging: syncFormData?.total_value_packaging,
          total_value_other_parcel: syncFormData?.total_value_other_parcel,
          total_value_shipping: syncFormData?.total_value_shipping,
          exemption_vat_products: syncFormData?.exemption_vat_products,
          exemption_vat_shipping: syncFormData?.exemption_vat_shipping,
          exemption_vat_packaging: syncFormData?.exemption_vat_packaging,
          sales_type: 2,
          button_type: 2,
          invoice_part_list: invoicePartList,
          is_moloni_invoice: updatedStatusChange?.is_moloni_invoice,
          exemption_reason: syncFormData?.exemption_reason,
        };

        createInternalInvoice(payload)
          .then((response) => {
            toast.success(response.data.message);
            navigate("/internal-sales");
            setSyncFormData({
              price_value: "",
              selected_ids: [],
            });
            setLoading(false);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluidcontainer-custom-height-new">
          <div className="row">
            <div className="col-md-12">
              <div className="card fuelCard">
                <div className="">
                  <div className="">
                    <div className="card-header">
                      <div className="card-title m-0 float-left d-flex">
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                          onClick={() => {
                            if (state?.pathname === "/accept-invoice-sales") {
                              navigate("/sales");
                            } else {
                              navigate("/internal-sales");
                            }
                          }}
                          style={{ width: "100px", marginTop: "10px" }}
                        >{t("back")}<i className="bi bi-arrow-left-short"></i>
                        </button>
                      </div>
                      <div className="card-title m-0 float-right d-flex">
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                          onClick={handleAddAccpetedStatusInternalSubmit}
                          style={{ width: "100px", marginTop: "10px" }}
                          disabled={loading} // disable while loading
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </>
                          ) : (
                            <>{t("submit")}<i className="bi bi-x-lg"></i>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary card-primary-Vehicle">
                <div className="vehicleparts-table-inner">
                  <div
                    className="row"
                    style={{ padding: "14px", marginBottom: "15px" }}
                  >
                    <div className="col-md-6">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadio"
                        id="flexRadio1"
                        value="1"
                        checked={selectedRadioAccepted === "1"}
                        onChange={handleRadioInternalSaleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadio1"
                        style={{ fontSize: "15px", fontWeight: "bolder" }}
                      >
                        Upload Pdf
                      </label>
                    </div>

                    <div className="col-md-6">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadio"
                        id="flexRadio2"
                        value="2"
                        checked={selectedRadioAccepted === "2"}
                        onChange={handleRadioInternalSaleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadio2"
                        style={{ fontSize: "15px", fontWeight: "bolder" }}
                      >
                        Create Invoice
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    {selectedRadioAccepted === "1" && (
                      <>
                        <div
                          className="col-md-12"
                          style={{ marginTop: "10px" }}
                        >
                          <div className="p-4 border rounded-lg">
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept=".pdf,.csv,.xls,.xlsx,.jpg,.jpeg,.png"
                              onChange={handleFileChangeImageInternal}
                              className="border p-2 rounded-md"
                            />

                            <div className="grid grid-cols-1 gap-2 mt-3">
                              {/* Image Preview */}
                              {imagePreview && (
                                <div className="mt-2">
                                  {imagePreview
                                    .toLowerCase()
                                    .endsWith(".pdf") ? (
                                    // PDF Preview
                                    <a
                                      href={imagePreview}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <iframe
                                        src={imagePreview}
                                        title="PDF Preview"
                                        width="200px"
                                        height="200px"
                                        style={{
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          cursor: "pointer",
                                        }}
                                        onClick={handleOpen}
                                      />
                                    </a>
                                  ) : (
                                    // Image Preview
                                    <a
                                      href={imagePreview}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{
                                          maxWidth: "200px",
                                          maxHeight: "200px",
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </a>
                                  )}
                                  <button
                                    onClick={removeFile}
                                    className="bg-red-500 text-white text-xs px-2 py-1 rounded ms-3"
                                    style={{ background: "red" }}
                                    disabled={imageLoader}
                                  >
                                    {imageLoader ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Removing...
                                      </>
                                    ) : (
                                      "Remove"
                                    )}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {loadingCustomerList ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "300px" }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      selectedRadioAccepted === "2" && (
                        <>
                          {Number(updatedStatusChange?.is_moloni_invoice) ===
                            0 && (
                            <>
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("date")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="date"
                                        value={syncFormData.date}
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            date: e.target.value,
                                          });
                                        }}
                                        name="date"
                                        placeholder={t("expiration_date")}
                                      />
                                    </div>
                                    {errors.date && (
                                      <span className="input-error">
                                        {errors.date}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("expirationDate")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="date"
                                        value={syncFormData.expiration_date}
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            expiration_date: e.target.value,
                                          });
                                        }}
                                        name="expiration_date"
                                        placeholder={t("expiration_date")}
                                      />
                                    </div>
                                    {errors.expiration_date && (
                                      <span className="input-error">
                                        {errors.expiration_date}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("documentSet")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={documentSetList}
                                        value={documentSetList.find(
                                          (item) =>
                                            item.value ===
                                            syncFormData.document_set_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            document_set_id: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Document Set"}
                                      />
                                      {errors.document_set_id && (
                                        <span className="input-error">
                                          {errors.document_set_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("customer")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                    <i
                                      className="bi bi-info-circle-fill"
                                      style={{
                                        marginLeft: "215px",
                                        color: "blue",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleCustomerModelOpen}
                                    ></i>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={customerList}
                                        value={customerList.find(
                                          (item) =>
                                            item.value ===
                                            syncFormData.customer_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            customer_id: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Customer"}
                                      />
                                      {errors.customer_id && (
                                        <span className="input-error">
                                          {errors.customer_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("our_reference")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={syncFormData.our_reference}
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            our_reference: e.target.value,
                                          });
                                        }}
                                        name="our_reference"
                                        placeholder={t("our_reference")}
                                      />
                                    </div>
                                    {errors.our_reference && (
                                      <span className="input-error">
                                        {errors.our_reference}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("your_reference")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={syncFormData.your_reference}
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            your_reference: e.target.value,
                                          });
                                        }}
                                        name="your_reference"
                                        placeholder={t("your_reference")}
                                      />
                                    </div>
                                    {errors.your_reference && (
                                      <span className="input-error">
                                        {errors.your_reference}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("notes")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={syncFormData.notes}
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            notes: e.target.value,
                                          });
                                        }}
                                        name="notes"
                                        placeholder={t("notes")}
                                      />
                                    </div>
                                    {errors.notes && (
                                      <span className="input-error">
                                        {errors.notes}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("total_value_packaging")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={
                                          syncFormData.total_value_packaging
                                        }
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            total_value_packaging:
                                              e.target.value,
                                          });
                                        }}
                                        name="total_value_packaging"
                                        placeholder={t("total_value_packaging")}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "+" ||
                                            e.key === "-"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        min="0"
                                      />
                                      {errors.total_value_packaging && (
                                        <span className="input-error">
                                          {errors.total_value_packaging}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("total_value_other_parcel")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={
                                          syncFormData.total_value_other_parcel
                                        }
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            total_value_other_parcel:
                                              e.target.value,
                                          });
                                        }}
                                        name="total_value_other_parcel"
                                        placeholder={t("total_value_other_parcel")}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "+" ||
                                            e.key === "-"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        min="0"
                                      />
                                      {errors.total_value_other_parcel && (
                                        <span className="input-error">
                                          {errors.total_value_other_parcel}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("total_value_shipping")}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={
                                          syncFormData.total_value_shipping
                                        }
                                        onChange={(e) => {
                                          setSyncFormData({
                                            ...syncFormData,
                                            total_value_shipping:
                                              e.target.value,
                                          });
                                        }}
                                        name="total_value_shipping"
                                        placeholder={t("total_value_shipping")}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "+" ||
                                            e.key === "-"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        min="0"
                                      />
                                      {errors.total_value_shipping && (
                                        <span className="input-error">
                                          {errors.total_value_shipping}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {"Exemption Vat Other Parcel"}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div ">
                                      <Select
                                        options={exemptionList}
                                        value={
                                          exemptionList.find(
                                            (option) =>
                                              option.value ===
                                              syncFormData.exemption_vat_products,
                                          ) || null
                                        }
                                        onChange={(selectedOption) =>
                                          setSyncFormData({
                                            ...syncFormData,
                                            exemption_vat_products:
                                              selectedOption
                                                ? selectedOption.value
                                                : "",
                                          })
                                        }
                                        placeholder={
                                          "Select Exemption Vat Other Parcel"
                                        }
                                        isClearable
                                        isSearchable
                                      />
                                      {errors.exemption_vat_products && (
                                        <span className="input-error">
                                          {errors.exemption_vat_products}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Exemption Vat Shipping"}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={exemptionList}
                                        value={
                                          exemptionList.find(
                                            (option) =>
                                              option.value ===
                                              syncFormData.exemption_vat_shipping,
                                          ) || null
                                        }
                                        onChange={(selectedOption) =>
                                          setSyncFormData({
                                            ...syncFormData,
                                            exemption_vat_shipping:
                                              selectedOption
                                                ? selectedOption.value
                                                : "",
                                          })
                                        }
                                        placeholder={
                                          "Select Exemption Vat Shipping"
                                        }
                                        isClearable
                                        isSearchable
                                      />
                                      {errors.exemption_vat_shipping && (
                                        <span className="input-error">
                                          {errors.exemption_vat_shipping}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Exemption Vat Packaging"}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={exemptionList}
                                        value={exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            syncFormData.exemption_vat_packaging,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSyncFormData({
                                            ...syncFormData,
                                            exemption_vat_packaging:
                                              selectedOption
                                                ? selectedOption.value
                                                : "",
                                          })
                                        }
                                        placeholder={
                                          "Select Exemption Vat Packaging"
                                        }
                                        isClearable
                                        isSearchable
                                      />
                                      {errors.exemption_vat_packaging && (
                                        <span className="input-error">
                                          {errors.exemption_vat_packaging}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label">
                                    {"Exemption Reason"}
                                    <span className="text-danger ms-1 fw-bold">
                                      *
                                    </span>
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        options={exemptionList}
                                        value={exemptionList.find(
                                          (option) =>
                                            option.value ===
                                            syncFormData.exemption_reason,
                                        )}
                                        onChange={(selectedOption) =>
                                          setSyncFormData({
                                            ...syncFormData,
                                            exemption_reason: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          })
                                        }
                                        placeholder={"Select Exemption Reason"}
                                        isClearable
                                        isSearchable
                                      />
                                      {errors.exemption_reason && (
                                        <span className="input-error">
                                          {errors.exemption_reason}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-4"></div>
                            </>
                          )}

                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="card-title m-0 float-left"
                                style={{ width: "50%" }}
                              >
                                <div className="Label-my mb-2 mt-2">
                                  Part Details
                                </div>
                              </div>
                              {updatedStatusChange?.generate_from_plugin !==
                                1 && (
                                <div className="card-title m-0 float-right d-flex">
                                  <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    style={{
                                      width: "125px",
                                      marginTop: "10px",
                                      marginBottom: "10px",
                                    }}
                                    onClick={() => {
                                      if (
                                        state?.pathname ===
                                        "/accept-invoice-sales"
                                      ) {
                                        navigate("/add-part-invoice-sales", {
                                          state: {
                                            selectedParts,
                                            statusChange: updatedStatusChange,
                                            selectedRadioAccepted: 2,
                                          },
                                        });
                                      } else {
                                        navigate("/add-part-invoice", {
                                          state: {
                                            selectedParts,
                                            statusChange: updatedStatusChange,
                                            selectedRadioAccepted: 2,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    Add More
                                  </button>
                                </div>
                              )}

                              <div
                                className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                                style={{
                                  height: "300px",
                                  minHeight: "500px",
                                }}
                              >
                                <table className="rounded-table table table-striped table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th>Part Name</th>
                                      <th>Sales Price</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {updatedStatusChange?.part_list?.length >
                                    0 ? (
                                      updatedStatusChange?.part_list?.map(
                                        (item, index) => (
                                          <tr key={index}>
                                            <td>{item?.product_name}</td>
                                            <td>
                                              <input
                                                type="number"
                                                className="form-control input-search"
                                                value={
                                                  item.internal_sales_price ??
                                                  item.price_without_vat ??
                                                  ""
                                                }
                                                onChange={(e) => {
                                                  const newPrice =
                                                    e.target.value;

                                                  // Update the state immutably
                                                  const newPartList = [
                                                    ...updatedStatusChange.part_list,
                                                  ];
                                                  newPartList[index] = {
                                                    ...newPartList[index],
                                                    internal_sales_price:
                                                      newPrice,
                                                    price_without_vat: newPrice,
                                                  };

                                                  // Update the main state
                                                  setUpdatedStatusChange({
                                                    ...updatedStatusChange,
                                                    part_list: newPartList,
                                                  });
                                                }}
                                                onKeyDown={(e) => {
                                                  if (
                                                    e.key === "e" ||
                                                    e.key === "E" ||
                                                    e.key === "+" ||
                                                    e.key === "-"
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                min="0"
                                                disabled={
                                                  Number(
                                                    updatedStatusChange?.generate_from_plugin,
                                                  ) === 1
                                                }
                                              />
                                            </td>
                                            <td>
                                              {item?.id ? (
                                                <>
                                                  <Select
                                                    className="my-select-v"
                                                    options={partdeletedList}
                                                    value={partdeletedList.find(
                                                      (option) =>
                                                        option.value ===
                                                        item.deleted_part_id,
                                                    )}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      // Update deleted_part_id per row
                                                      const newPartList = [
                                                        ...updatedStatusChange.part_list,
                                                      ];
                                                      newPartList[index] = {
                                                        ...newPartList[index],
                                                        deleted_part_id:
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "",
                                                      };
                                                      setUpdatedStatusChange({
                                                        ...updatedStatusChange,
                                                        part_list: newPartList,
                                                      });
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={
                                                      "Select Deleted Part"
                                                    }
                                                    isDisabled={
                                                      Number(
                                                        updatedStatusChange?.generate_from_plugin,
                                                      ) === 1
                                                    }
                                                  />
                                                </>
                                              ) : (
                                                <div
                                                  className="trash-btn delete-btn"
                                                  onClick={() => {
                                                    // Remove the clicked item
                                                    const newPartList =
                                                      updatedStatusChange.part_list.filter(
                                                        (_, i) => i !== index,
                                                      );
                                                    setUpdatedStatusChange({
                                                      ...updatedStatusChange,
                                                      part_list: newPartList,
                                                    });
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="bi bi-trash3"></i>
                                                </div>
                                              )}
                                            </td>
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr className="scrollBrdr">
                                        <td colSpan="100%">No results found</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={customerModel}>
          <ModalHeader>Details</ModalHeader>

          {state?.pathname === "/accept-invoice-sales" ? (
            <>
              <ModalBody>
                {customerAllList?.map((item) => {
                  return (
                    <>
                      {item?.seller_invoice_provider === true && (
                        <div className="row">
                          <div>
                            {item?.provider_list?.map((items) => {
                              return (
                                <>
                                  <div className="col-md-12">
                                    <h6>Name : {items?.name}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Phone : {items?.phone}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Email : {items?.email}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Whatsapp : {items?.whatsapp}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>VAT Number : {items?.vat_number}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>
                                      Shipping Address :{" "}
                                      {items?.shipping_address}
                                    </h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Postal Code : {items?.postal_code}</h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>
                                      Country Code VAT Number :{" "}
                                      {items?.country_code_vat_number}
                                    </h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>
                                      Country Code : {items?.country_code}
                                    </h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>City : {items?.city}</h6>
                                  </div>{" "}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {item?.seller_invoice_client === true && (
                        <div className="row">
                          <div>
                            {item?.client_list?.map((items) => {
                              return (
                                <>
                                  <div className="col-md-12">
                                    <h6>Name : {items?.name}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Phone : {items?.phone}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Email : {items?.email}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Whatsapp : {items?.whatsapp}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>VAT Number : {items?.vat_number}</h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>
                                      Shipping Address :{" "}
                                      {items?.shipping_address}
                                    </h6>
                                  </div>
                                  <div className="col-md-12">
                                    <h6>Postal Code : {items?.postal_code}</h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>
                                      Country Code VAT Number :{" "}
                                      {items?.country_code_vat_number}
                                    </h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>
                                      Country Code : {items?.country_code}
                                    </h6>
                                  </div>{" "}
                                  <div className="col-md-12">
                                    <h6>City : {items?.city}</h6>
                                  </div>{" "}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </ModalBody>
            </>
          ) : (
            <ModalBody>
              <div className="row">
                <div>
                  <>
                    <div className="col-md-12">
                      <h6>Name : {customerAllList?.client_details?.name}</h6>
                    </div>
                    <div className="col-md-12">
                      <h6>
                        Phone : {customerAllList?.client_details?.phone_number}
                      </h6>
                    </div>
                    <div className="col-md-12">
                      <h6>Email : {customerAllList?.client_details?.email}</h6>
                    </div>
                    <div className="col-md-12">
                      <h6>
                        Whatsapp :{" "}
                        {customerAllList?.client_details?.whatsapp_number}
                      </h6>
                    </div>
                    <div className="col-md-12">
                      <h6>
                        VAT Number :{" "}
                        {customerAllList?.client_details?.vat_number}
                      </h6>
                    </div>
                    <div className="col-md-12">
                      <h6>
                        Shipping Address :{" "}
                        {customerAllList?.client_details?.shipping_address?.map(
                          (item, index) => (
                            <p key={index}>{item}</p>
                          ),
                        )}{" "}
                      </h6>
                    </div>
                    <div className="col-md-12">
                      <h6>
                        Postal Code :{" "}
                        {customerAllList?.client_details?.postal_code}
                      </h6>
                    </div>{" "}
                    <div className="col-md-12">
                      <h6>
                        Country Code VAT Number :{" "}
                        {customerAllList?.client_details?.vat_country_code}
                      </h6>
                    </div>{" "}
                    <div className="col-md-12">
                      <h6>
                        Country Code :{" "}
                        {customerAllList?.client_details?.country_code}
                      </h6>
                    </div>{" "}
                    <div className="col-md-12">
                      <h6>City : {customerAllList?.client_details?.city}</h6>
                    </div>{" "}
                  </>
                </div>
              </div>
            </ModalBody>
          )}

          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCustomerModelClose}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>
      </section>
    </div>
  );
};

export default AcceptedInternal;
